<template>
    <div>
        <transition name="scroll-y-transition" appear>
            <div v-if="!loading && !capRunning" class="page welcome-page">
                <e-section 
                    img="vector.png" 
                    description="في يلاستيب نسعي لتقديم التعليم بمفهومه الشامل و العصري حيث يبدأ بالمهارات الاساسية و ينمو بالتجربة و ينضج بالاختبار خطتنا هي انتاج محتوي تعليمي مميز في الكورسات الدراسية و كذلك كورسات المهارات و استخدام الامتحانات كاداة تقييم تساعدك علي الوصول لبداية طريق احلامك بشكل أسرع و أذكى"
                    :button1="{text: 'سجل اﻵن', icon: 'mdi-login-variant', color: 'secondary', to: {name: 'register'}}"
                    :button2="{text: 'تصفح الدورات', icon: 'mdi-play-circle', color: 'primary', to: {name: 'courses'}}"
                    
                >
                    <h1 class="headline" slot="headline" style="font-size: 2.6rem!important">
                        بداية أحلامك تبدأ من التعليم الجيد 
                    </h1>
                </e-section>

                <section v-if="featuredCourses && featuredCourses.length" :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container :class="{'px-0': phoneOnly}">
                        <div v-if="pcOnly">
                            <v-row>
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in featuredCourses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                        </div>
                        <v-list v-else two-line class="px-0">
                            <course-list-item v-for="(course, i) in featuredCourses" class="px-7 px-lg-4" :key="course.id + '-' + i" :course="course" />
                        </v-list>

                        <div class="mt-5 mt-lg-10 d-flex justify-center">
                            <v-btn text :to="{name: 'courses'}">
                                عرض كل الدورات التعليمية
                                <v-icon size="20" class="ms-2" right>mdi-chevron-left</v-icon>
                            </v-btn>
                        </div>
                    </v-container>
                </section>

                <slot name="footer" />
            </div>
        </transition>


        <!-- <app-welcome-dialog v-if="capRunning" v-model="appWelcomeDialog" /> -->
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

// import AppWelcomeDialog from '@/components/default/dialogs/app-welcome'
import ESection from '@/components/default/layouts/e-section'

import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Welcome",
    data(){
        return {
            loading: false,
        }
    },
    components: {
        ESection,
        CourseCard,
        CourseListItem,
        // AppWelcomeDialog,
    },
    computed: {
        ...GlobalComputed,
        welcomeData(){
            return this.$store.state.globalModule.welcomeData;
        },
        featuredCourses(){
            return this.welcomeData.featured_courses;
        }
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadWelcomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    // this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    created(){
        if (this.capRunning){
            // this.appWelcomeDialog = true;
            this.$router.push({name: 'login'});
        }else{
            if (!this.featuredCourses || this.featuredCourses.length === 0){
                this.loadData();
            }
        }
    }
};
</script>
